import { createElement } from 'react';

interface WeaveSkeletonItemProps extends React.HTMLAttributes<HTMLElement> {
	width: string;
	height: string;
	radius: string;
	marginbottom?: string;
}

export function WeaveSkeletonItem({
	className,
	width,
	height,
	radius,
	marginbottom,
	...rest
}: WeaveSkeletonItemProps) {
	return createElement('weave-skeleton-item', {
		className,
		width,
		height,
		radius,
		marginbottom,
		...rest,
	});
}
